export default "__VITE_PUBLIC_ASSET__24b0e4c8__"